export default [

    {
        path: '',
        name: 'comunicados',
        redirect: { name: 'comunicados-caixa-de-entrada' },
    },

    {
        path: 'caixa-de-entrada',
        name: 'comunicados-caixa-de-entrada',
        component: () => import('@/aplicacao/modulos/comunicados/CaixaDeEntrada'),
        meta: { autenticacao: true, permissao: 'ROLE_COMUNICADOS' },
    },

    {
        path: 'importantes',
        name: 'comunicados-importantes',
        component: () => import('@/aplicacao/modulos/comunicados/Importantes'),
        meta: { autenticacao: true, permissao: 'ROLE_COMUNICADOS' },
    },

    {
        path: 'emitidos',
        name: 'comunicados-emitidos',
        component: () => import('@/aplicacao/modulos/comunicados/Emitidos'),
        meta: { autenticacao: true, permissao: 'ROLE_COMUNICADOS' },
    },

    {
        path: 'historico',
        name: 'comunicados-historico',
        component: () => import('@/aplicacao/modulos/comunicados/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_COMUNICADOS_HISTORICO' },
    },

    {
        path: 'formulario/:id?',
        name: 'comunicados-formulario',
        component: () => import('@/aplicacao/modulos/comunicados/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_COMUNICADOS_EMITIR' },
    },

]
